import React from "react";
import {Button, Col, Form, Nav, Row, Tab} from '@themesberg/react-bootstrap';
import BasePage from "../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty, parseDate} from "enqc-utilities/src/utils/Utilities";
import BorrowingOfItemTable from "./BorrowingOfItemTable";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import SearchInput from "../../components/input/SearchInput";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";
import FilterButton from "../../components/FilterButton";
import SmartDeviceFilterModal from "../../components/SmartDeviceFilterModal";
import UserFilterModal from "../../components/UserFilterModal";
import GoodsCategoryFilterModal from "../../components/GoodsCategoryFilterModal";
import BorrowingOfItemModal from "../../components/BorrowingOfItemModal";
import DateFilterButton from "../../components/DateFilterButton";
import {DD_MM_YYYY} from "../../utils/Global";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";

let borrowingOfItemTableRef = React.createRef();

class BorrowingOfItemPage extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            borrowingOfItemStatuses:this.defaultBorrowingOfItemStatus(),
            defaultActiveTab:"0",
            activeTab:0,
            categoryFilter:false,
            userFilter:false,
            deviceFilter:false,
            filteredSmartDevices:new Set([]),
            filteredUsers:new Set([]),
            filteredGoodsCategories:new Set([]),
            selectedBorrowingOfItem:{},
            borrowingOfItemModal:false,
            color:'blue',
            tabDataSize:{},
            borrowingStartDate:undefined,
            borrowingEndDate:undefined,
            returningStartDate:undefined,
            returningEndDate:undefined,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        if(this.props?.navBar?.current){
            this.props.navBar.current.updateNavBarItems([BorrowingOfItemPage.PAGE_CONF])
        }

        this.closePreLoader()
        this.fetchBorrowingOfItemStatus()
    }
    defaultBorrowingOfItemStatus(){
        let borrowingOfItemStatuses = []
        let allBorrowingOfItemStatus = {
            id:0,
            label:label.All,
            active:true,
            iconLink:ApplicationIcons.Icons.lines,
        }
        borrowingOfItemStatuses.push(allBorrowingOfItemStatus)
        return borrowingOfItemStatuses
    }

    fetchBorrowingOfItemStatus = () => {
        let {borrowingOfItemStatuses,activeTab,defaultActiveTab} = this.state
        this.get(Endpoint.API.BORROWING_ITEM_STATUSES, {
            params :{
                sortir: "id",
                ascending:true,
            }
        }, null, response=>{
            if(response.code===200){
                borrowingOfItemStatuses = this.defaultBorrowingOfItemStatus();
                borrowingOfItemStatuses.push(...response.data)
                let tabDataSize = {}
                for(let borrowingOfItemStatus of borrowingOfItemStatuses){
                    tabDataSize[borrowingOfItemStatus.id] = 0
                }
                this.setState({borrowingOfItemStatuses:borrowingOfItemStatuses, tabDataSize},() => this.forceUpdate())
            }else{
                this.props.history.goBack();
            }
        }, false, true)
    }

    fetchBorrowingOfItems(downloadExcel){
        let {search, sortOption, activeTab, filteredSmartDevices, filteredUsers, filteredGoodsCategories, borrowingStartDate, borrowingEndDate, returningStartDate, returningEndDate} = this.state
        this.setState({activeTab:downloadExcel?activeTab:0},
            () => {
                this.borrowingOfItemTableRef.fetchBorrowingOfItems(search, sortOption, filteredSmartDevices, filteredUsers, filteredGoodsCategories, borrowingStartDate, borrowingEndDate, returningStartDate, returningEndDate, downloadExcel)
            })
    }
    tabDataCallback(id, size){
        let {tabDataSize} = this.state
        tabDataSize[id] = size
        this.setState({tabDataSize})
    }

    render() {
        let {borrowingOfItemStatuses, defaultActiveTab, activeTab,
            selectedBorrowingOfItem, borrowingOfItemModal, userFilter, deviceFilter, categoryFilter,
            filteredGoodsCategories, filteredSmartDevices, filteredUsers,
            tabDataSize,
            borrowingStartDate, borrowingEndDate, returningStartDate, returningEndDate,
            pageElement, totalPage, totalElement, sortOption} = this.state

        let dateFilterActive = false
        if(borrowingStartDate || borrowingEndDate || returningStartDate || returningEndDate){
            dateFilterActive = true
        }

        return (
            <>
                <GoodsCategoryFilterModal
                    show={categoryFilter}
                    selectedGoodsCategories={filteredGoodsCategories}
                    onClose={()=>{
                        this.setState({categoryFilter:false})
                    }}
                    onSelect={(selectedGoodsCategories)=>{
                        this.setState({categoryFilter:false, filteredGoodsCategories:selectedGoodsCategories}, () => {
                            this.fetchBorrowingOfItems()
                        })
                    }}/>
                <SmartDeviceFilterModal
                    show={deviceFilter}
                    selectedSmartDevices={filteredSmartDevices}
                    onClose={()=>{
                        this.setState({deviceFilter:false})
                    }}
                    onSelect={(selectedSmartDevices)=>{
                        this.setState({deviceFilter:false, filteredSmartDevices:selectedSmartDevices}, () => {
                            this.fetchBorrowingOfItems()
                        })
                    }}/>
                <UserFilterModal
                    show={userFilter}
                    selectedUsers={filteredUsers}
                    onClose={()=>{
                        this.setState({userFilter:false})
                    }}
                    onSelect={(selectedUsers)=>{
                        this.setState({userFilter:false, filteredUsers:selectedUsers}, () => {
                            this.fetchBorrowingOfItems()
                        })
                    }}/>
                <BorrowingOfItemModal
                    show={borrowingOfItemModal}
                    onClose={()=>{
                        this.setState({borrowingOfItemModal:false, selectedBorrowingOfItem:{}})
                    }}
                    showProcessing={this.props.showProcessing}
                    closeProcessing={this.props.closeProcessing}
                    borrowingOfItem={selectedBorrowingOfItem}/>
                <Row>
                    <Col>
                        <Row className="mb-3 align-items-center">
                            <Col xl={4}>
                                <SearchInput
                                    onEnter={(search) => {
                                        this.setState({search}, () => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }} onEmpty={() => {
                                    this.setState({search:""},() => {
                                        this.fetchBorrowingOfItems()
                                    })
                                }}/>
                            </Col>
                            <Col xs={4} md={4} xl={2} className="ps-md-0">
                                <TableSortOption
                                    sortOptions={
                                        [
                                            SortOption.init(label.Latest,"boi.borrowedAt",false),
                                            SortOption.init(label.Oldest,"boi.borrowedAt",true),
                                        ]
                                    }
                                    sortOption={sortOption}
                                    placeholder={label.SortBy}
                                    onSelect={(sortOption) => {
                                        this.setState({sortOption},() => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }}
                                    onReset={() => {
                                        this.setState({sortOption:{}},() => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }}/>
                            </Col>
                            <Col xs={4} md={4} xl={6} className="ps-md-0 text-right">
                                <FilterButton
                                    label={label.CategoryFilter}
                                    active={filteredGoodsCategories.size>0}
                                    onReset={() => {
                                        this.setState({
                                            filteredGoodsCategories:new Set([])
                                        }, () => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }}
                                    onClick={() => {
                                        this.setState({categoryFilter:true})
                                    }}/>
                                &nbsp;
                                &nbsp;
                                <FilterButton
                                    label={label.UserFilter}
                                    active={filteredUsers.size>0}
                                    onReset={() => {
                                        this.setState({
                                            filteredUsers:new Set([])
                                        }, () => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }}
                                    onClick={() => {
                                        this.setState({userFilter:true})
                                    }}/>
                                &nbsp;
                                &nbsp;
                                <FilterButton
                                    label={label.DeviceFilter}
                                    active={filteredSmartDevices.size>0}
                                    onReset={() => {
                                        this.setState({
                                            filteredSmartDevices:new Set([])
                                        }, () => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }}
                                    onClick={() => {
                                        this.setState({deviceFilter:true})
                                    }}/>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col className="border-end p-3 bg-gray-300">
                                <Row>
                                    <Col>
                                        <Form.Label>{label.BorrowingDate}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <DateFilterButton
                                                title={borrowingStartDate?parseDate(borrowingStartDate, DD_MM_YYYY):label.StartDate}
                                                maximumDate={borrowingEndDate}
                                                value={borrowingStartDate}
                                                onSelect={(value)=>{
                                                    this.setState({borrowingStartDate:value}, () => {
                                                        this.fetchBorrowingOfItems()
                                                    })
                                        }}/>
                                    </Col>
                                    <Col>
                                        <DateFilterButton
                                            title={borrowingEndDate?parseDate(borrowingEndDate, DD_MM_YYYY):label.EndDate}
                                            minimumDate={borrowingStartDate}
                                            value={borrowingEndDate}
                                            onSelect={(value)=>{
                                                this.setState({borrowingEndDate:value}, () => {
                                                    this.fetchBorrowingOfItems()
                                                })
                                        }}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className="border-end p-3 bg-gradient-gray-400">
                                <Row>
                                    <Col>
                                        <Form.Label>{label.ReturningDate}</Form.Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <DateFilterButton
                                            title={returningStartDate?parseDate(returningStartDate, DD_MM_YYYY):label.StartDate}
                                            maximumDate={returningEndDate}
                                            value={returningStartDate}
                                            onSelect={(value)=>{
                                                this.setState({returningStartDate:value}, () => {
                                                    this.fetchBorrowingOfItems()
                                                })
                                        }}/>
                                    </Col>
                                    <Col>
                                        <DateFilterButton
                                            title={returningEndDate?parseDate(returningEndDate, DD_MM_YYYY):label.EndDate}
                                            minimumDate={returningStartDate}
                                            value={returningEndDate}
                                            onSelect={(value)=>{
                                                this.setState({returningEndDate:value}, () => {
                                                    this.fetchBorrowingOfItems()
                                                })
                                        }}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={1} className="border-end p-3 bg-gray-300">
                                <Button
                                    variant={dateFilterActive?"outline-danger":"outline-dark"}
                                    style={{backgroundColor:'white', color:'black'}} disabled={!dateFilterActive}
                                    onClick={event => {
                                        this.setState({borrowingStartDate:undefined, borrowingEndDate:undefined, returningStartDate:undefined, returningEndDate:undefined}, () => {
                                            this.fetchBorrowingOfItems()
                                        })
                                    }}>
                                    {label.ResetFilterDate}
                                </Button>
                            </Col>
                            <Col md={1} className="border-end p-3 bg-gray-400">
                                <Button
                                    variant={"outline-success"}
                                    style={{backgroundColor:'white', color:'green'}}
                                    onClick={event => {
                                        this.fetchBorrowingOfItems(true)
                                    }}>
                                    <FontAwesomeIcon icon={faFileExcel} size="sm"/>&nbsp;
                                    {label.DownloadExcel}
                                </Button>
                            </Col>
                            <Col md={4}>

                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    !isEmpty(defaultActiveTab)?
                                        (
                                            <Tab.Container defaultActiveKey={defaultActiveTab}>
                                                <Nav fill variant="tabs" className="flex-column flex-sm-row p-0">
                                                    {
                                                        borrowingOfItemStatuses.map((item, index)=>(
                                                            <Nav.Link
                                                                eventKey={item.id}
                                                                className={"mb-sm-3 mb-md-0 mx-1 p-2 text-black "+(item.id === activeTab?'bg-soft-green':'bg-white')}
                                                                onSelect={eventKey => {
                                                                    this.setState({activeTab:item.id})
                                                                }}
                                                                disabled={!item.active}>
                                                                <img style={{width:'24px'}} src={item.iconLink}/>&nbsp;
                                                                <span style={{color:(item.id === activeTab?'white':item.color)}}>{label(item.label)}</span>
                                                                <span style={{color:(item.id === activeTab?'white':item.color), fontWeight:'bold'}}>{" ("+tabDataSize[item.id]+")"}</span>
                                                            </Nav.Link>

                                                        ))
                                                    }
                                                </Nav>
                                                <Tab.Content>
                                                    {
                                                        borrowingOfItemStatuses.map((borrowingOfItemStatus, index)=>(
                                                            <Tab.Pane eventKey={borrowingOfItemStatus.id} className="py-4">
                                                                <BorrowingOfItemTable
                                                                    {...this.props}
                                                                    showProcessing={this.props.showProcessing}
                                                                    closeProcessing={this.props.closeProcessing}
                                                                    ref={(ref)=>{
                                                                        if(borrowingOfItemStatus.id === activeTab){
                                                                            this.borrowingOfItemTableRef = ref
                                                                        }
                                                                    }}
                                                                    show={borrowingOfItemStatus.id === activeTab}
                                                                    borrowingOfItemStatus={borrowingOfItemStatus}
                                                                    onSelect={(selectedBorrowingOfItem) => {
                                                                        this.setState({selectedBorrowingOfItem, borrowingOfItemModal:true})
                                                                    }}
                                                                    tabDataCallback={(id, size)=>{
                                                                        this.tabDataCallback(id, size)
                                                                    }}
                                                                />
                                                            </Tab.Pane>
                                                        ))
                                                    }
                                                </Tab.Content>

                                            </Tab.Container>
                                        )
                                        :
                                        (null)
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        );
    }
}
// export default Object.assign(BorrowingOfItemPage, {ENDPOINT : "/borrowingOfItems"})

const ENDPOINT = "/borrowingOfItems"
const TITLE = label.BorrowingOfItemList
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(BorrowingOfItemPage, PAGE)


